import { Button, formatNumbers, LoadingWrapper, MainLayoutContainer } from '@lune-fe/lune-ui-lib'
import CloseIcon from '@mui/icons-material/Close'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import Box from '@mui/material/Box'
import { ReactNode, RefObject, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import useTitle from 'hooks/useTitle'

import DownloadPdfButton from './DownloadPdfButton'

const ResultsWrapper = ({
    children,
    calculatedAmount,
    scrollRef,
    loading,
    estimateId,
    token,
    isMultiLeg,
}: {
    children: ReactNode
    calculatedAmount: string
    scrollRef: RefObject<HTMLDivElement>
    loading?: boolean
    estimateId?: string
    token?: string | null
    isMultiLeg?: boolean
}) => {
    useTitle('Emissions Calculations')
    const allQueryParams = useLocation().search

    const navigate = useNavigate()
    useEffect(() => {
        scrollRef.current?.scrollTo({ top: 0 })
    }, [scrollRef])

    return (
        <LoadingWrapper loading={loading} sx={{ height: 1 }}>
            {!loading && (
                <MainLayoutContainer
                    headerComponent={
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Button
                                iconButton
                                leftIcon={<CloseIcon />}
                                variant={'text'}
                                sx={{ ml: -1.5 }}
                                onClick={() => navigate(`/calculate-emissions${allQueryParams}`)}
                                data-testid={'logistics-results-close-button'}
                            />
                            <Box
                                sx={{
                                    gap: 2,
                                    display: 'flex',
                                }}
                            >
                                {estimateId && token && isMultiLeg !== undefined && (
                                    <DownloadPdfButton
                                        id={estimateId}
                                        token={token}
                                        isMultiLeg={isMultiLeg}
                                    />
                                )}
                                <Button
                                    variant={'contained'}
                                    leftIcon={<CloudDownloadOutlinedIcon />}
                                    onClick={() =>
                                        navigate(
                                            `/order?amount=${formatNumbers(calculatedAmount, 2)}`,
                                        )
                                    }
                                >
                                    Offset Now
                                </Button>
                            </Box>
                        </Box>
                    }
                >
                    {children}
                </MainLayoutContainer>
            )}
        </LoadingWrapper>
    )
}

export default ResultsWrapper
